import Api from './api'
import { getXUserKey, getXAPIEnv } from '@/plugins/account'

export default {

  List (search) {
    return Api('store', 'customers', 'get', { search }, { 'x-user-key': getXUserKey(), 'x-api-env': getXAPIEnv() })
  },

  Total () {
    return Api('store', 'customers', 'get', {}, { 'x-user-key': getXUserKey(), 'x-api-env': getXAPIEnv(), 'x-pagination-index': 0, 'x-pagination-limit': 1 })
  },
  Get (customerId) {
    return Api('store', `customers/${customerId}`, 'get', {}, { 'x-user-key': getXUserKey(), 'x-api-env': getXAPIEnv() })
  },

  GetFromPhone (phone, type = '', showLoading = true) {
    return Api('store', `customers`, 'get', {'phone': phone, 'type': type}, { 'x-user-key': getXUserKey(), 'x-api-env': getXAPIEnv() }, showLoading)
  },

  GetConfigurations (customerId, showLoading = true) {
    return Api('store', `customers/${customerId}/configurations`, 'get', {}, { 'x-user-key': getXUserKey(), 'x-api-env': getXAPIEnv() }, showLoading)
  },

  addAnnotation(customerId, annotation) {
    return Api('store', `customer/${customerId}/annotation`, 'post', { annotation }, { 'x-user-key': getXUserKey(), 'x-api-env': getXAPIEnv() });
  },
  deleteAnnotation(customerId, annotation) {
    return Api('store', `customer/${customerId}/annotation`, 'delete', {}, { 'x-user-key': getXUserKey(), 'x-api-env': getXAPIEnv() });
  },
  setLastDeliveryAddress(customerId, lastDeliveryAddressSelected) {
    return Api('store', `customers/${customerId}/lastDeliveryAddress`, 'put', { lastDeliveryAddressSelected }, { 'x-user-key': getXUserKey(), 'x-api-env': getXAPIEnv() });
  }
}
